import types from './types';

const initData = {
  switch: 0,
  times: 0,
};

const getLoadsClickTimes = () => {
  const jsonData = localStorage.getItem('loadsClickTimes')
    ? JSON.parse(localStorage.getItem('loadsClickTimes'))
    : {};
  let times = jsonData.times;
  const localStorageDay = jsonData.dayTime ? jsonData.dayTime : null;
  const date = new Date();
  const nowDay = `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}`;
  if (localStorageDay !== nowDay) {
    times = 0;
  }
  return times;
};

const saveLoadsClickTimes = (state) => {
  const newTimes = Number(state.localLoadsClickTimes) + 1;
  const date = new Date();
  const nowDay = `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}`;
  const loadsTimesObj = {
    times: newTimes,
    dayTime: nowDay,
  };
  localStorage.setItem('loadsClickTimes', JSON.stringify(loadsTimesObj));
  return newTimes;
};


const initialState = {
  loading: false,
  error: false,
  memberSwitchData: {},
  localLoadsClickTimes: getLoadsClickTimes(),
};

const reducer = (state, action) => {
  switch (action.type) {
    case types.MEMBER_SWITCH: {
      if (action.pending) {
        return {
          ...state,
          memberSwitchData: initData,
          loading: true,
          error: false,
        };
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          memberSwitchData: Object.assign({}, state.memberSwitchData, action.payload.data),
          loading: false,
          error: false,
        };
      }
      return {
        ...state,
        loading: false,
        memberSwitchData: initData,
        error: action.payload.message || action.error,
      };
    }

    case types.SAVE_LOADS_CLICK_TIMES: {
      return {
        ...state,
        localLoadsClickTimes: saveLoadsClickTimes(state),
      };
    }

    default:
      return state;
  }
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/premiumSwitch/reducer.js